var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import Caption from "../Caption";
import Text from "../Text";
import { Col, Row } from "../grid";
import React from 'react';
import { layout, space } from 'styled-system';
import { css, styled } from "../../utils";
import Radio from "./Radio";
var Container = styled.div(layout, space);
var Error = styled.aside(function (_a) {
    var _b = _a.theme, colors = _b.colors, font = _b.font;
    return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    position: absolute;\n    font-family: ", ";\n    color: ", ";\n    text-align: left;\n    font-size: 0.75rem;\n    letter-spacing: 0.04rem;\n    padding: 0.5rem 0;\n    font-style: italic;\n  "], ["\n    position: absolute;\n    font-family: ", ";\n    color: ", ";\n    text-align: left;\n    font-size: 0.75rem;\n    letter-spacing: 0.04rem;\n    padding: 0.5rem 0;\n    font-style: italic;\n  "])), font.family.proximaNova, colors.red);
});
var RadioGroup = function (_a) {
    var name = _a.name, currentValue = _a.value, values = _a.values, label = _a.label, layout = _a.layout, error = _a.error, props = __rest(_a, ["name", "value", "values", "label", "layout", "error"]);
    return (React.createElement(Container, { "data-component": "RadioGroup", width: "100%", mb: "2rem" },
        label && React.createElement(Text, null, label),
        React.createElement(Row, { flexDirection: "row", flexWrap: "wrap", m: -1 }, values.map(function (_a) {
            var hint = _a.hint, item = __rest(_a, ["hint"]);
            return (React.createElement(Col, { key: item.value, width: layout === 'horizontal' ? [1, 1 / 2] : 1, p: 1, display: "flex" },
                React.createElement(Radio, __assign({ key: "radio-" + name + "-" + item.value, name: name, error: error, checked: item.value === currentValue }, props, item)),
                hint && React.createElement(Caption, { light: true }, hint)));
        })),
        error && React.createElement(Error, null, error)));
};
RadioGroup.defaultProps = {
    layout: 'horizontal',
};
export default RadioGroup;
var templateObject_1;
//# sourceMappingURL=RadioGroup.js.map